(function () {
  var ROOT_SELECTOR = "[data-h-quantity-breaks]";
  var READY_ATTR = "hQuantityBreaksReady";
  var SYNCING_ATTR = "hQuantityBreaksSyncing";
  var pendingRoot = null;
  var listenersBound = false;

  function getForm(root) {
    if (!root) return null;
    return root.closest("form") || document.getElementById(root.getAttribute("data-h-form-id") || "");
  }

  function getQuantityInputs(root) {
    var form = getForm(root);
    var inputs = [];
    if (!form) return inputs;

    var selector = root.getAttribute("data-h-quantity-input");
    if (selector) {
      var main = form.querySelector(selector);
      if (main) inputs.push(main);
    }

    var named = form.querySelector('input[name="quantity"]');
    if (named && inputs.indexOf(named) === -1) {
      inputs.push(named);
    }

    return inputs;
  }

  function parseQuantity(value) {
    var quantity = parseInt(value, 10);
    return quantity > 0 ? quantity : 1;
  }

  function getRadios(root) {
    return Array.prototype.slice.call(root.querySelectorAll("[data-h-quantity-breaks-radio]"));
  }

  function getSelectedRadio(root) {
    return root.querySelector("[data-h-quantity-breaks-radio]:checked");
  }

  function setTierSelectedState(root, selectedRadio) {
    var tiers = root.querySelectorAll("[data-h-quantity-breaks-tier]");
    Array.prototype.forEach.call(tiers, function (tier) {
      var radio = tier.querySelector("[data-h-quantity-breaks-radio]");
      var isSelected = selectedRadio && radio === selectedRadio;
      tier.classList.toggle("h-quantity-breaks__tier--selected", isSelected);
    });
  }

  function setFormQuantity(root, quantity) {
    var inputs = getQuantityInputs(root);
    root.dataset[SYNCING_ATTR] = "true";

    inputs.forEach(function (input) {
      input.value = String(quantity);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    window.requestAnimationFrame(function () {
      delete root.dataset[SYNCING_ATTR];
    });
  }

  function getRadioFromEvent(event, root) {
    var target = event.target;
    if (!target || !target.closest) return null;

    var radio = target.closest("[data-h-quantity-breaks-radio]");
    if (radio && root.contains(radio)) return radio;

    var tier = target.closest("[data-h-quantity-breaks-tier]");
    if (!tier || !root.contains(tier)) return null;

    return tier.querySelector("[data-h-quantity-breaks-radio]");
  }

  function applySelectedTier(root, updateQuantity) {
    var radio = getSelectedRadio(root);
    setTierSelectedState(root, radio);

    if (updateQuantity === false) return;

    if (!radio) {
      setFormQuantity(root, 1);
      return;
    }

    setFormQuantity(root, parseQuantity(radio.getAttribute("data-h-quantity")));
  }

  function syncTierFromQuantity(root) {
    if (root.dataset[SYNCING_ATTR] === "true") return;

    var inputs = getQuantityInputs(root);
    if (!inputs.length) return;

    var quantity = parseQuantity(inputs[0].value);
    var match = getRadios(root).filter(function (radio) {
      return parseQuantity(radio.getAttribute("data-h-quantity")) === quantity;
    })[0];

    if (match) {
      if (!match.checked) {
        match.checked = true;
      }
      setTierSelectedState(root, match);
      return;
    }

    getRadios(root).forEach(function (radio) {
      radio.checked = false;
    });
    setTierSelectedState(root, null);
  }

  function parseVariantPrices(tier) {
    var node = tier.querySelector("[data-h-quantity-breaks-variant-prices]");
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function applyVariantPrices(root, variantId) {
    if (!variantId) return;

    var id = String(variantId);
    var tiers = root.querySelectorAll("[data-h-quantity-breaks-tier]");

    Array.prototype.forEach.call(tiers, function (tier) {
      var prices = parseVariantPrices(tier);
      if (!prices || !prices[id]) return;

      var data = prices[id];
      var sale = tier.querySelector("[data-h-quantity-breaks-sale]");
      var compare = tier.querySelector("[data-h-quantity-breaks-compare]");
      var badge = tier.querySelector("[data-h-quantity-breaks-badge]");

      if (sale) sale.textContent = data.sale || "";

      if (compare) {
        compare.textContent = data.compare || "";
        if (data.show_compare) {
          compare.removeAttribute("hidden");
        } else {
          compare.setAttribute("hidden", "");
        }
      }

      if (badge) {
        badge.textContent = data.badge || "";
        if (data.show_badge && data.badge) {
          badge.removeAttribute("hidden");
          tier.classList.add("h-quantity-breaks__tier--has-badge");
        } else {
          badge.setAttribute("hidden", "");
          tier.classList.remove("h-quantity-breaks__tier--has-badge");
        }
      }
    });

    root.setAttribute("data-h-current-variant-id", id);
  }

  function getCartUrl() {
    var cartUrl = (window.routes && window.routes.cartUrl) || "/cart";
    return cartUrl.replace(/\/$/, "");
  }

  function fetchCart() {
    return fetch(getCartUrl() + ".js", {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart fetch failed");
      return response.json();
    });
  }

  function updateCartDiscount(codes) {
    return fetch(getCartUrl() + "/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        discount: codes.join(",")
      })
    });
  }

  function normalizeCode(code) {
    return String(code || "").trim();
  }

  function getKnownCodes(root) {
    return String(root.getAttribute("data-h-quantity-breaks-codes") || "")
      .split(",")
      .map(normalizeCode)
      .filter(Boolean);
  }

  function getSelectedCode(root) {
    var radio = getSelectedRadio(root);
    if (!radio) return "";
    return normalizeCode(radio.getAttribute("data-h-discount-code"));
  }

  function codesMatch(a, b) {
    return a.map(function (code) {
      return code.toLowerCase();
    }).sort().join(",") === b.map(function (code) {
      return code.toLowerCase();
    }).sort().join(",");
  }

  function syncCartDiscount(root) {
    var known = getKnownCodes(root);
    var selected = getSelectedCode(root);

    if (!known.length && !selected) {
      return Promise.resolve();
    }

    return fetchCart().then(function (cart) {
      var current = (cart.discount_codes || []).map(function (item) {
        return normalizeCode(item && item.code);
      }).filter(Boolean);

      var knownLookup = {};
      known.forEach(function (code) {
        knownLookup[code.toLowerCase()] = true;
      });

      var next = current.filter(function (code) {
        return !knownLookup[code.toLowerCase()];
      });

      if (selected) {
        var alreadyIncluded = next.some(function (code) {
          return code.toLowerCase() === selected.toLowerCase();
        });
        if (!alreadyIncluded) next.push(selected);
      }

      if (codesMatch(current, next)) return;

      return updateCartDiscount(next);
    }).catch(function () {
      return null;
    });
  }

  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true
    }));
  }

  function initRoot(root) {
    if (!root || root.dataset[READY_ATTR] === "true") return;

    var radios = getRadios(root);
    if (!radios.length) return;

    root.dataset[READY_ATTR] = "true";
    applySelectedTier(root, true);

    root.addEventListener("pointerdown", function (event) {
      var radio = getRadioFromEvent(event, root);
      if (!radio) return;
      radio.dataset.hQuantityBreaksWasChecked = radio.checked ? "true" : "false";
    });

    root.addEventListener("click", function (event) {
      var radio = getRadioFromEvent(event, root);
      if (!radio) return;

      var wasChecked = radio.dataset.hQuantityBreaksWasChecked === "true";
      delete radio.dataset.hQuantityBreaksWasChecked;
      if (!wasChecked) return;

      event.preventDefault();
      event.stopPropagation();
      radio.checked = false;
      applySelectedTier(root, true);
    }, true);

    root.addEventListener("keydown", function (event) {
      if (event.key !== " " && event.key !== "Spacebar") return;

      var radio = event.target.closest("[data-h-quantity-breaks-radio]");
      if (!radio || !root.contains(radio) || !radio.checked) return;

      event.preventDefault();
      radio.checked = false;
      applySelectedTier(root, true);
    });

    root.addEventListener("change", function (event) {
      if (!event.target.closest("[data-h-quantity-breaks-radio]")) return;
      applySelectedTier(root, true);
    });

    getQuantityInputs(root).forEach(function (input) {
      input.addEventListener("change", function () {
        syncTierFromQuantity(root);
      });
      input.addEventListener("input", function () {
        syncTierFromQuantity(root);
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll ? context.querySelectorAll(ROOT_SELECTOR) : [];

    Array.prototype.forEach.call(roots, initRoot);

    if (context.matches && context.matches(ROOT_SELECTOR)) {
      initRoot(context);
    }
  }

  function findRootFromNode(node) {
    if (!node || !node.closest) return null;
    var form = node.closest("form");
    if (form) {
      var nested = form.querySelector(ROOT_SELECTOR);
      if (nested) return nested;
    }
    return node.closest(ROOT_SELECTOR);
  }

  function bindGlobalListeners() {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener("variant:changed", function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;

      var scope = event.target && event.target.querySelectorAll ? event.target : document;
      var roots = scope.querySelectorAll(ROOT_SELECTOR);

      if (!roots.length && document.contains(event.target)) {
        var closestRoot = findRootFromNode(event.target);
        roots = closestRoot ? [closestRoot] : document.querySelectorAll(ROOT_SELECTOR);
      }

      Array.prototype.forEach.call(roots, function (root) {
        applyVariantPrices(root, variant.id);
      });
    });

    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-h-add-multiple-to-cart]");
      if (!button) return;

      var root = findRootFromNode(button);
      if (!root) return;

      pendingRoot = root;
      syncCartDiscount(root);
    }, true);

    document.addEventListener("product:added", function () {
      var root = pendingRoot;
      pendingRoot = null;
      if (!root) return;

      syncCartDiscount(root).then(function () {
        refreshCartDrawer();
      });
    });

    document.addEventListener("shopify:section:load", function (event) {
      initAll(event.target);
    });

    document.addEventListener("shopify:block:select", function (event) {
      var tier = event.target && event.target.closest
        ? event.target.closest("[data-h-quantity-breaks-tier]")
        : null;
      if (!tier) return;

      var root = tier.closest(ROOT_SELECTOR);
      var radio = tier.querySelector("[data-h-quantity-breaks-radio]");
      if (!root || !radio) return;

      radio.checked = true;
      applySelectedTier(root, true);
    });
  }

  function onReady() {
    bindGlobalListeners();
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
